/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { ShapeMapPb } from "../../../../gen/shape_map/shape_map";

export const protobufPackage = "skills";

export interface UpdateShapeMapActionArgs {
  shapeMap: ShapeMapPb | undefined;
  relativeToVehicle: boolean;
}

export interface UpdateShapeMapResultData {
}

export interface UpdateShapeMapActionStateData {
}

function createBaseUpdateShapeMapActionArgs(): UpdateShapeMapActionArgs {
  return { shapeMap: undefined, relativeToVehicle: false };
}

export const UpdateShapeMapActionArgs = {
  encode(message: UpdateShapeMapActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.shapeMap !== undefined) {
      ShapeMapPb.encode(message.shapeMap, writer.uint32(10).fork()).ldelim();
    }
    if (message.relativeToVehicle === true) {
      writer.uint32(16).bool(message.relativeToVehicle);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateShapeMapActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateShapeMapActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.shapeMap = ShapeMapPb.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.relativeToVehicle = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateShapeMapActionArgs {
    return {
      shapeMap: isSet(object.shapeMap) ? ShapeMapPb.fromJSON(object.shapeMap) : undefined,
      relativeToVehicle: isSet(object.relativeToVehicle) ? globalThis.Boolean(object.relativeToVehicle) : false,
    };
  },

  toJSON(message: UpdateShapeMapActionArgs): unknown {
    const obj: any = {};
    if (message.shapeMap !== undefined) {
      obj.shapeMap = ShapeMapPb.toJSON(message.shapeMap);
    }
    if (message.relativeToVehicle === true) {
      obj.relativeToVehicle = message.relativeToVehicle;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateShapeMapActionArgs>, I>>(base?: I): UpdateShapeMapActionArgs {
    return UpdateShapeMapActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateShapeMapActionArgs>, I>>(object: I): UpdateShapeMapActionArgs {
    const message = createBaseUpdateShapeMapActionArgs();
    message.shapeMap = (object.shapeMap !== undefined && object.shapeMap !== null)
      ? ShapeMapPb.fromPartial(object.shapeMap)
      : undefined;
    message.relativeToVehicle = object.relativeToVehicle ?? false;
    return message;
  },
};

function createBaseUpdateShapeMapResultData(): UpdateShapeMapResultData {
  return {};
}

export const UpdateShapeMapResultData = {
  encode(_: UpdateShapeMapResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateShapeMapResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateShapeMapResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateShapeMapResultData {
    return {};
  },

  toJSON(_: UpdateShapeMapResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateShapeMapResultData>, I>>(base?: I): UpdateShapeMapResultData {
    return UpdateShapeMapResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateShapeMapResultData>, I>>(_: I): UpdateShapeMapResultData {
    const message = createBaseUpdateShapeMapResultData();
    return message;
  },
};

function createBaseUpdateShapeMapActionStateData(): UpdateShapeMapActionStateData {
  return {};
}

export const UpdateShapeMapActionStateData = {
  encode(_: UpdateShapeMapActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateShapeMapActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateShapeMapActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateShapeMapActionStateData {
    return {};
  },

  toJSON(_: UpdateShapeMapActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateShapeMapActionStateData>, I>>(base?: I): UpdateShapeMapActionStateData {
    return UpdateShapeMapActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateShapeMapActionStateData>, I>>(_: I): UpdateShapeMapActionStateData {
    const message = createBaseUpdateShapeMapActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
